module.exports = __webpack_public_path__ + "static/media/ebuilt-banner-mobile.825a28e8.jpg";